import React from 'react';
import styled from 'styled-components';
import { Alert } from 'antd';
import { Content } from './Layout';
/**
 * https://reactjs.org/docs/error-boundaries.html
 */
export class ErrorBoundary extends React.PureComponent {
    state = {};
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        // If there's no error, just return what renders via the happy path.
        if (!this.state.error) {
            return this.props.children;
        }
        const showErrorDetails = process.env.NODE_ENV === 'development';
        const description = showErrorDetails ? (React.createElement(React.Fragment, null,
            React.createElement("b", null,
                this.state.error.message,
                ":"),
            React.createElement(DebugInfo, null,
                React.createElement("pre", null, this.state.error.stack || JSON.stringify(this.state.error, null, 2))))) : (React.createElement(React.Fragment, null, this.props.defaultErrorMessage || 'Sorry, something went wrong. Please try again.'));
        return (React.createElement(Content, null,
            React.createElement(Alert, { type: "error", message: "Error", description: description, showIcon: true })));
    }
}
const DebugInfo = styled.code `
    ${({ theme }) => `
        display: block;
        padding: ${theme.spacing.md.toString()};
        margin: ${theme.spacing.sm.toString()} 0 0;
        overflow: auto;
        pre {
            margin: 0;
            padding: 0;
            overflow: initial;
        }
    `}
`;
//# sourceMappingURL=ErrorBoundary.js.map